var Polyfills = function () {
    
    var initStatus = {
        responsImg: false
    };

    var placeholder = function () {
        if (!feature.placeholder) {
            UL.getScript('https://cdnjs.cloudflare.com/ajax/libs/placeholders/4.0.1/placeholders.min.js');
        }
    };
    
    var responsImg = function (callback) {
        
        if ((!initStatus.responsImg) && (!feature.srcset  || !feature.pictureElement)
           ) {
            UL.getScriptCdn(
                'https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.js',
                config.bowerPath + 'picturefill/dist/picturefill.min.js',
                callback
            );
              
            initStatus.responsImg = true;
        } else {
            if (callback !== undefined) {
                callback();
            }
        }    
    }
    
    var init = function () {
        placeholder();
    }; 
    
    return {
        responsImg: responsImg,
        init: init
    };    
}();

UL.register(Polyfills);
